import { render, staticRenderFns } from "./RulesTapestry.vue?vue&type=template&id=0dadc987"
import script from "./RulesTapestry.vue?vue&type=script&lang=ts"
export * from "./RulesTapestry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports